export default __webpack_public_path__ + "52fb8380a9da4234e1f792743a887b42.png";